import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const CancelCircle = ({
  size = 16,
  title = 'Cancel',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 30.01 30">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M19.49,19.38a1.4,1.4,0,0,0-.11-1.75l-2.72-2.71,2.7-2.7a1.23,1.23,0,0,0,0-1.72h0l-.07-.06a1.17,
1.17,0,0,0-1.63.11L15,13.25l-2.7-2.7a1.24,1.24,0,0,0-1.75,1.75l2.7,2.7-2.71,2.7a1.25,1.25,0,
0,0,0,1.75h0a1.22,1.22,0,0,0,1.73,0L15,16.74l2.69,2.7a1.21,1.21,0,0,0,1.71,0l.07-.06Z
`}
        fill={fill}
      />
      <path
        d={`
M25.61,4.39A15,15,0,1,0,15,30h0A15,15,0,0,0,25.61,4.39ZM27.73,
15A12.72,12.72,0,0,1,15,27.72h0A12.72,12.72,0,1,1,27.73,15Z
`}
        fill={fill}
      />
    </svg>
  );
};
